<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" :loading="loading" />

        <div class="card">
          <div class="card-body">
            <div class="table-top report-toolbar">
              <div class="report-controls">
                <div class="report-top-actions">
                  <button type="button" class="btn btn-secondary" @click="exportToCSV">
                    Export CSV
                  </button>
                </div>

                <div class="row report-filter-row">
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <label class="report-filter-label">Month</label>
                      <select v-model="selectedMonth" class="form-control" @change="applyMonthRange">
                        <option v-for="(month, index) in months" :key="month" :value="index + 1">
                          {{ month }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <label class="report-filter-label">Year</label>
                      <select v-model="selectedYear" class="form-control" @change="applyMonthRange">
                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <label class="report-filter-label">Start Date</label>
                      <div class="input-groupicon">
                        <datepicker
                          v-model="startDate"
                          placeholder="Start Date"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                          @update:modelValue="timeframechange"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <label class="report-filter-label">End Date</label>
                      <div class="input-groupicon">
                        <datepicker
                          v-model="endDate"
                          placeholder="End Date"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                          @update:modelValue="timeframechange"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <label class="report-filter-label">Search</label>
                      <input
                        v-model="searchText"
                        type="search"
                        class="form-control"
                        placeholder="Search category, item, branch..."
                      />
                    </div>
                  </div>

                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group report-action-group">
                      <button type="button" class="btn btn-submit" :disabled="loading" @click="generateReport">
                        Generate Report
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <a-table
                :columns="activeColumns"
                :data-source="filteredData"
                :pagination="{ pageSize: 25, showSizeChanger: true }"
                :scroll="{ x: 1800 }"
                row-key="rowKey"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const detailColumns = [
  {
    title: "Category Name",
    dataIndex: "categoryname",
    sorter: (a, b) => (a.categoryname || "").localeCompare(b.categoryname || ""),
  },
  {
    title: "Item Name",
    dataIndex: "itemname",
    sorter: (a, b) => (a.itemname || "").localeCompare(b.itemname || ""),
  },
  {
    title: "Record Date",
    dataIndex: "recorddate",
    sorter: (a, b) => (a.recorddate || "").localeCompare(b.recorddate || ""),
  },
  {
    title: "Record Type",
    dataIndex: "recordtype",
    sorter: (a, b) => (a.recordtype || "").localeCompare(b.recordtype || ""),
  },
  {
    title: "Unit",
    dataIndex: "unit",
    sorter: (a, b) => (a.unit || "").localeCompare(b.unit || ""),
  },
  {
    title: "Unit Price",
    dataIndex: "unitprice",
    sorter: (a, b) => toNumeric(a.unitprice) - toNumeric(b.unitprice),
    customRender: ({ text }) => formatCurrency(text),
  },
  {
    title: "Invoice Date",
    dataIndex: "invoicedate",
    sorter: (a, b) => (a.invoicedate || "").localeCompare(b.invoicedate || ""),
  },
  {
    title: "Branch",
    dataIndex: "branch",
    sorter: (a, b) => (a.branch || "").localeCompare(b.branch || ""),
  },
  {
    title: "Dealer",
    dataIndex: "dealer",
    sorter: (a, b) => (a.dealer || "").localeCompare(b.dealer || ""),
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    sorter: (a, b) => toNumeric(a.quantity) - toNumeric(b.quantity),
  },
  {
    title: "Amount",
    dataIndex: "amount",
    sorter: (a, b) => toNumeric(a.amount) - toNumeric(b.amount),
    customRender: ({ text }) => formatCurrency(text),
  },
  {
    title: "Opening Balance",
    dataIndex: "opening_balance",
    sorter: (a, b) => toNumeric(a.opening_balance) - toNumeric(b.opening_balance),
  },
  {
    title: "Closing Balance",
    dataIndex: "closing_balance",
    sorter: (a, b) => toNumeric(a.closing_balance) - toNumeric(b.closing_balance),
  },
  {
    title: "Opening Amount",
    dataIndex: "opening_amount",
    sorter: (a, b) => toNumeric(a.opening_amount) - toNumeric(b.opening_amount),
    customRender: ({ text }) => formatCurrency(text),
  },
  {
    title: "Closing Amount",
    dataIndex: "closing_amount",
    sorter: (a, b) => toNumeric(a.closing_amount) - toNumeric(b.closing_amount),
    customRender: ({ text }) => formatCurrency(text),
  },
];

function formatDate(date) {
  const formattedDate = new Date(date);
  const year = formattedDate.getFullYear();
  const month = String(formattedDate.getMonth() + 1).padStart(2, "0");
  const day = String(formattedDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function isValidDate(date) {
  return date && !Number.isNaN(new Date(date).getTime());
}

function toNumeric(value) {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }

  const sanitized = String(value).replace(/[^0-9.-]/g, "");
  const parsed = parseFloat(sanitized);
  return Number.isFinite(parsed) ? parsed : 0;
}

function formatCurrency(value) {
  const amount = toNumeric(value);
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export default {
  name: "generalreport",
  data() {
    const now = new Date();
    return {
      title: "General Report",
      title1: "View stock movement report by date range",
      loading: false,
      selectedMonth: now.getMonth() + 1,
      selectedYear: now.getFullYear(),
      startDate: new Date(now.getFullYear(), now.getMonth(), 1),
      endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0),
      timeframechanged: false,
      refreshTimer: null,
      reportRequestId: 0,
      searchText: "",
      data: [],
      detailColumns,
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
      ],
      years: Array.from({ length: 5 }, (_, index) => now.getFullYear() - index),
    };
  },
  computed: {
    activeColumns() {
      return this.detailColumns;
    },
    filteredData() {
      const query = this.searchText.trim().toLowerCase();
      return this.data
        .map((item, index) => ({
          ...item,
          rowKey: `${item.itemid || "item"}-${item.recorddate || "stock"}-${item.recordtype || "row"}-${index}`,
        }))
        .filter((item) => {
          if (!query) {
            return true;
          }

          return [
            item.categoryname,
            item.itemname,
            item.recorddate,
            item.recordtype,
            item.unit,
            item.invoicedate,
            item.branch,
            item.dealer,
          ].some((value) => String(value || "").toLowerCase().includes(query));
        });
    },
  },
  methods: {
    applyMonthRange() {
      this.startDate = new Date(this.selectedYear, this.selectedMonth - 1, 1);
      this.endDate = new Date(this.selectedYear, this.selectedMonth, 0);
      this.timeframechange();
    },
    timeframechange() {
      this.timeframechanged = true;
      this.scheduleReportRefresh();
    },
    scheduleReportRefresh() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => {
        const { valid } = this.validateDateRange(false);
        if (valid) {
          this.generateReport(false);
        } else {
          this.reportRequestId += 1;
          this.data = [];
          this.loading = false;
        }
      }, 250);
    },
    getDateRange() {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
      };
    },
    validateDateRange(showAlert = true) {
      const { startDate, endDate } = this.getDateRange();

      if (!isValidDate(startDate) || !isValidDate(endDate)) {
        if (showAlert) {
          window.Swal.fire("Missing dates", "Please select both start and end dates.", "warning");
        }
        return { valid: false, startDate, endDate };
      }

      if (new Date(startDate) > new Date(endDate)) {
        if (showAlert) {
          window.Swal.fire("Invalid range", "Start date cannot be after end date.", "warning");
        }
        return { valid: false, startDate, endDate };
      }

      return { valid: true, startDate, endDate };
    },
    async generateReport(showAlert = true) {
      clearTimeout(this.refreshTimer);
      const { valid, startDate, endDate } = this.validateDateRange(showAlert);

      if (!valid) {
        this.reportRequestId += 1;
        this.data = [];
        this.loading = false;
        this.timeframechanged = true;
        return;
      }

      const requestId = this.reportRequestId + 1;
      this.reportRequestId = requestId;
      this.loading = true;
      this.data = [];
      try {
        const apiUrl = `/v1/generalreport?startdate=${formatDate(startDate)}&enddate=${formatDate(endDate)}`;

        const response = await axios.get(apiUrl);
        if (requestId !== this.reportRequestId) {
          return;
        }

        this.data = response.data || [];
        this.timeframechanged = false;
      } catch (error) {
        if (requestId !== this.reportRequestId) {
          return;
        }

        console.error("Error fetching general report", error);
        window.Swal.fire("Error", "Unable to load general report.", "error");
      } finally {
        if (requestId === this.reportRequestId) {
          this.loading = false;
        }
      }
    },
    async exportToCSV() {
      if (this.timeframechanged) {
        await this.generateReport();
      }

      if (!this.filteredData.length) {
        window.Swal.fire("No data", "Generate a report before exporting.", "info");
        return;
      }

      const headers = this.activeColumns.map((column) => column.title);
      const keys = this.activeColumns.map((column) => column.dataIndex);
      const rows = this.filteredData.map((item) =>
        keys.map((key) => `"${String(item[key] ?? "").replace(/"/g, '""')}"`).join(",")
      );

      const csvContent = [headers.join(","), ...rows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const { startDate, endDate } = this.getDateRange();
      const filename = `general_report_${formatDate(startDate)}_${formatDate(endDate)}.csv`;

      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
  },
  beforeMount() {
    this.generateReport();
  },
  beforeUnmount() {
    clearTimeout(this.refreshTimer);
  },
};
</script>

<style scoped>
.report-toolbar {
  align-items: flex-start;
}

.report-controls {
  width: 100%;
}

.report-top-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;
}

.report-filter-row {
  align-items: flex-end;
}

.report-filter-label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #5b667a;
}

.report-action-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.picker {
  width: 100%;
}
</style>
